import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Import Tailwind's base styles
import App from './App.jsx'; // Import your main component (now named App.jsx)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
